import React from "react";
import choose from "../assets/topo-1.jpg";

function ChooseUs() {
  return (
    <section className="">
      <img
        src={choose}
        alt="Background"
        className="absolute top-0 left-0 w-full h-full object-cover z-0 opacity-5"
      />

      <div class="container relative z-40 mx-auto min-h-screen md:min-h-[90vh]">
        <h1 class="mx-auto max-w-7xl mb-4 font-display text-4xl font-bold tracking-normal py-8 text-center text-white-300 sm:text-7xl">
          Why Choose
          <span class="relative whitespace-nowrap text-orange-500 dark:text-orange-300">
            <span class="relative"> us </span>
          </span>
        </h1>
        <div class="flex flex-wrap justify-center mx-auto lg:w-full md:w-5/6 xl:shadow-small-blue bg-white/70">
          <a href="#" class="block w-1/2 py-10 text-center border lg:w-1/4">
            <div>
              <img
                src="https://redpixelthemes.com/assets/images/icon-portfolio-green.svg"
                class="block mx-auto"
              />
              <p class="pt-4 text-sm font-medium capitalize font-body text-green-900 lg:text-lg md:text-base md:pt-6">
                Assistance on Daily Basis
              </p>
            </div>
          </a>
          <a href="#" class="block w-1/2 py-10 text-center border lg:w-1/4">
            <div>
              <img
                src="https://redpixelthemes.com/assets/images/icon-blog-green.svg"
                class="block mx-auto"
              />
              <p class="pt-4 text-sm font-medium capitalize font-body text-green-900 lg:text-lg md:text-base md:pt-6">
                Risk Managed Calls
              </p>
            </div>
          </a>
          <a href="#" class="block w-1/2 py-10 text-center border lg:w-1/4">
            <div>
              <img
                src="https://redpixelthemes.com/assets/images/icon-ecommerce-green.svg"
                class="block mx-auto"
              />
              <p class="pt-4 text-sm font-medium capitalize font-body text-green-900 lg:text-lg md:text-base md:pt-6">
                SEBI Registered Registration Number
              </p>
            </div>
          </a>

          <a href="#" class="block w-1/2 py-10 text-center border lg:w-1/4">
            <div>
              <img
                src="https://redpixelthemes.com/assets/images/icon-startup-green.svg"
                class="block mx-auto"
              />

              <p class="pt-4 text-sm font-medium capitalize font-body text-green-900 lg:text-lg md:text-base md:pt-6">
                Award Winning Research and Advice
              </p>
            </div>
          </a>

          <a href="#" class="block w-1/2 py-10 text-center border lg:w-1/4">
            <div>
              <img
                src="https://redpixelthemes.com/assets/images/icon-business-green.svg"
                class="block mx-auto"
              />

              <p class="pt-4 text-sm font-medium capitalize font-body text-green-900 lg:text-lg md:text-base md:pt-6">
                Happy Customers
              </p>
            </div>
          </a>

          <a href="#" class="block w-1/2 py-10 text-center border lg:w-1/4">
            <div>
              <img
                src="https://redpixelthemes.com/assets/images/icon-lifestyle-green.svg"
                class="block mx-auto"
              />

              <p class="pt-4 text-sm font-medium capitalize font-body text-green-900 lg:text-lg md:text-base md:pt-6">
                High Reward Low Risk Ratio
              </p>
            </div>
          </a>

          <a href="#" class="block w-1/2 py-10 text-center border lg:w-1/4">
            <div>
              <img
                src="https://redpixelthemes.com/assets/images/icon-landing-page-green.svg"
                class="block mx-auto"
              />

              <p class="pt-4 text-sm font-medium capitalize font-body text-green-900 lg:text-lg md:text-base md:pt-6">
                Certified Professional Advisor
              </p>
            </div>
          </a>

          <a href="#" class="block w-1/2 py-10 text-center border lg:w-1/4">
            <div>
              <img
                src="https://redpixelthemes.com/assets/images/icon-health-green.svg"
                class="block mx-auto"
              />

              <p class="pt-4 text-sm font-medium capitalize font-body text-green-900 lg:text-lg md:text-base md:pt-6">
                Ethical and Transparent Practices
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export default ChooseUs;
